import { gql, useMutation } from "@apollo/client";

const MUTATION = gql`
  mutation ResendConfirmationEmail($email: String!, $phoneNumber: String) {
    resendConfirmationEmail(email: $email, phoneNumber: $phoneNumber)
  }
`;

export const useResendConfirmationEmail = () => {
  const [resendConfirmationEmail, { loading, error }] = useMutation(MUTATION);

  const handleResendConfirmationEmail = async (email: string, phoneNumber?: string) => {
    try {
      console.log('🔍 GraphQL mutation: About to call resendConfirmationEmail with:', {
        email,
        phoneNumber: phoneNumber || 'none'
      });
      console.log('🔍 GraphQL mutation: resendConfirmationEmail function:', resendConfirmationEmail);
      
      const { data } = await resendConfirmationEmail({
        variables: { 
          email,
          ...(phoneNumber ? { phoneNumber } : {})
        },
      });
      
      console.log('🔍 GraphQL mutation: Received data:', data);
      console.log('🔍 GraphQL mutation: resendConfirmationEmail result:', data.resendConfirmationEmail);
      
      return data.resendConfirmationEmail;
    } catch (err) {
      console.error('🔍 GraphQL mutation: Error occurred:', err);
      return { error: "Error occurred while resending confirmation email" };
    }
  };

  return {
    handleResendConfirmationEmail,
    loading,
    error,
  };
};
